<div class="c100 {{ colorClass }} {{ percentClass }}" *ngIf="!data">
  <span class="{{ colorClass }}">{{ tempo }}</span>

  <div class="slice">
    <div class="bar"></div>
    <div class="fill"></div>
  </div>
</div>
